import { Stack } from "@mui/material"
import React, { useEffect, useState } from "react"
import UseGetStepHookDucPage from "../UseGetStepHookDucPage"
import PiModal from "./PiModal"
import DUCDeleteModal from './DUCDeleteModal';
import GeneralBlockStepper from "./GeneralBlockStepper";
import GeneralBlockButtons from "./GeneralBlockButtons";
import { useUserInfoQuery } from "../../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";
import { getRenewalStatus } from "../utils/renewalWindow";

const GeneralBlockComponent = () => {
    const [activeStep, setActiveStep] = useState(1);
    //We need expiry and expired because we need a different 
    //status chip for each one
    const [expiring, setExpiring] = useState(false);
    const [expired, setExpired] = useState(false);
    const [declined, setDeclined] = useState(false);
    const [checkedCurrentStatus, setCheckedCurrentStatus] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    // const [secondDucExists, setSecondDucExists] = useState(false)
    const [cancelRefresh, setCancelRefresh] = useState(false)
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });
    const ducData = ducDataObject?.GENERAL?.[ducDataObject?.GENERAL.length - 1]

    UseGetStepHookDucPage(ducData, setActiveStep, setExpired, setExpiring, setDeclined, setCheckedCurrentStatus)

    // When BE returns multiple DUCs (e.g., Approved and Declined), ensure expiring/expired reflect the Approved one
    useEffect(() => {
        const generalList = ducDataObject?.GENERAL as any[] | undefined;
        if (!generalList || generalList.length === 0) return;

        // Find the most recent Approved DUC (iterate from the end)
        let latestApproved: any | null = null;
        for (let i = generalList.length - 1; i >= 0; i--) {
            if (generalList[i]?.status === 'Approved') {
                latestApproved = generalList[i];
                break;
            }
        }

        if (latestApproved) {
            const { expired: isExpired, expiring: isExpiring } = getRenewalStatus({
                status: latestApproved?.status,
                expiresOn: latestApproved?.expiresOn,
            });
            setExpired(isExpired);
            setExpiring(isExpiring);
        }
    }, [ducDataObject]);

    return (
        <Stack
            component="section"
            aria-labelledby="general-use-header"
            flexDirection="column"
            justifyContent="space-between"
            gap={3}
            padding="20px"
            sx={{
                backgroundColor: "white"
            }}>
            <PiModal open={open} setOpen={setOpen} type="GENERAL"/>
            <DUCDeleteModal
                open={openDeleteModal}
                setOpen={setOpenDeleteModal}
                type="GENERAL"
                cancelRefresh={cancelRefresh}
                setCancelRefresh={setCancelRefresh}/>

            <GeneralBlockButtons
                expired={expired || ducDataObject?.ducStatus === 'DucExpired'}
                expiring={expiring}
                setOpen={setOpen}
                setCancelRefresh={setCancelRefresh}
                cancelRefresh={cancelRefresh}
                setOpenDeleteModal={setOpenDeleteModal}
                checkedCurrentStatus={checkedCurrentStatus}/>

            <Stack>
                {/* Once the user's overall status is DucExpired, only show a single stepper
                    (the current/most recent GENERAL record) instead of one per record - avoids
                    rendering a duplicate-looking timeline for an older Approved-then-expired row
                    alongside a newer Submitted/InProgress renewal row. */}
                {ducDataObject?.ducStatus === 'DucExpired'
                    ? (
                        <GeneralBlockStepper
                            ducData={ducData}
                            declined={declined}
                            expired={expired}
                            key={0}
                            index={0}
                            activeStep={activeStep}
                        />
                    )
                    : ducDataObject?.GENERAL.map((generalDucData: any, index: number) => {
                        return (
                            <GeneralBlockStepper
                                ducData={generalDucData}
                                declined={declined}
                                expired={expired}
                                key={index}
                                index={index}
                                activeStep={activeStep}
                            />
                        )
                    })}
            </Stack>


        </Stack>
    )


}


export default GeneralBlockComponent